// [stiffness, damping]
export const normal = [170, 26];
export const inertial = [60, 26];
export const wobbly = [180, 12];



// WEBPACK FOOTER //
// ./lib/pagehandler/math/springconstants.js